/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {ProductSummary} from '../models/ProductSummary';

export interface GetAccountProductFilterOptions$Request {
    accountId: number;
}

export interface GetAccountProductFilterOptions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountProductFilterOptionsRequest = createAction<PayloadData<void, GetAccountProductFilterOptions$Request>>('GET_ACCOUNT_PRODUCT_FILTER_OPTIONS__GET_ACCOUNT_PRODUCT_FILTER_OPTIONS__REQUEST');
export const getAccountProductFilterOptionsSuccess = createAction<PayloadData<Array<ProductSummary>, GetAccountProductFilterOptions$Request>>('GET_ACCOUNT_PRODUCT_FILTER_OPTIONS__GET_ACCOUNT_PRODUCT_FILTER_OPTIONS__SUCCESS');
export const getAccountProductFilterOptionsFailure = createAction<PayloadData<Error, GetAccountProductFilterOptions$Request, true>>('GET_ACCOUNT_PRODUCT_FILTER_OPTIONS__GET_ACCOUNT_PRODUCT_FILTER_OPTIONS__FAILURE');

export const getAccountProductFilterOptionsActions = [
    getAccountProductFilterOptionsRequest,
    getAccountProductFilterOptionsSuccess,
    getAccountProductFilterOptionsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountProductFilterOptions = (meta: GetAccountProductFilterOptions$Request, config?: GetAccountProductFilterOptions$Config) => {
    return {
        CALL_API: {
            types: getAccountProductFilterOptionsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/users/product-filter-options`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

